export default __webpack_public_path__ + "static/media/breadCrumbIcon.16d19962.svg";